@if(this.isFetching){
    <div class="bloc_loading">
        <ion-spinner></ion-spinner>
    </div>        
}
@else{

    <marv-select 
        label="{{ 'OPERATION' | translate }}" 
        icon="briefcase-outline" 
        formName="currentPearlsOperationId" 
        [items]="this.operationsPearls" 
        [withSpeechToText]="true"
        />
    
    @for(photoSearchCriteria of this.photoSearchCriterias | keyvalue; track photoSearchCriteria.key){
    
        <div 
            class="photo_search_criterias"
            [class.show]="photoSearchCriteria.key === this.formGroupDirective.form.controls['currentPearlsOperationId'].value"
            >
            @if(photoSearchCriteria.value.photoTagCriteriaChunks && photoSearchCriteria.value.photoTagCriteriaChunks.length > 0){
                <div class="filter_title">
                    <marv-section-title label="{{'VISIT_PHOTOS' | translate}}" />
                    <marv-button 
                        [icon]="(this.photoTagAllChecked.get(photoSearchCriteria.key) === true ? 'square-outline' : 'checkbox-outline')" 
                        [rounded]="true" 
                        [disabled]="this.formGroupDirective.form.controls['pearls_enableTaggedPictures_'+photoSearchCriteria.key].value === false"
                        size="small" 
                        (click)="this.toggleCheckVisitPhotos(photoSearchCriteria.key, photoSearchCriteria.value.photoTagCriteriaChunks)" 
                        />  
                    <marv-toggle 
                        [formName]="'pearls_enableTaggedPictures_'+photoSearchCriteria.key" 
                        [noMargin]="true"
                        />
                </div>
                <div class="checkbox_filters">
                    @for(rows of photoSearchCriteria.value.photoTagCriteriaChunks; track $index){
                        @for(tag of rows; track $index){
                            <marv-checkbox 
                                [label]="tag.name" 
                                [formName]="'pearls_photoTag_'+photoSearchCriteria.key+'_'+tag.id" 
                                [disabled]="this.formGroupDirective.form.controls['pearls_enableTaggedPictures_'+photoSearchCriteria.key].value === false" 
                                labelPlacement="end"
                                /> 
                        }
                    }
                </div>
            }
            
            @if(photoSearchCriteria.value.prDmPhotoCriteriaChunks && photoSearchCriteria.value.prDmPhotoCriteriaChunks.length > 0 && photoSearchCriteria.value.productCategories?.hasProducts){
                <div class="filter_title">
                    <marv-section-title label="{{'PRODUCTS_QUESTIONNAIRE' | translate}}" />                      
                    <marv-toggle 
                        [formName]="'pearls_enableProductPictures_'+photoSearchCriteria.key" 
                        [noMargin]="true"
                        />                
                </div>    
                                   
                <marv-item>
                    <div class="item_filter_title">
                        {{'QUESTIONS' | translate}}
                        <div class="button_toggle_check">
                            <marv-button 
                                [icon]="(this.photoProductQuestionAllChecked.get(photoSearchCriteria.key) === true ? 'square-outline' : 'checkbox-outline')" 
                                [rounded]="true" 
                                [disabled]="this.formGroupDirective.form.controls['pearls_enableProductPictures_'+photoSearchCriteria.key].value === false"
                                size="small" 
                                (click)="this.toggleCheckPhotoProductQuestion(photoSearchCriteria.key, photoSearchCriteria.value.prDmPhotoCriteriaChunks)" 
                                />
                        </div>
                    </div>
                    
                    <div class="checkbox_filters">
                        @for(rows of photoSearchCriteria.value.prDmPhotoCriteriaChunks; track $index){
                            @for(question of rows; track $index){
                                <marv-checkbox 
                                    [label]="question.name" 
                                    [formName]="'pearls_photoProductQuestion_'+photoSearchCriteria.key+'_'+question.id" 
                                    [disabled]="this.formGroupDirective.form.controls['pearls_enableProductPictures_'+photoSearchCriteria.key].value === false"
                                    labelPlacement="end"
                                    /> 
                            }
                        }
                    </div>
                </marv-item>
               
                @if(photoSearchCriteria.value.productCategories && photoSearchCriteria.value.productCategories.productCategory && photoSearchCriteria.value.productCategories.productCategory.length > 0){ 
                                        
                    <marv-item>
                       <div class="item_filter_title">
                            {{'PRODUCTS' | translate}}
                            <div class="button_toggle_check">
                                <marv-button 
                                    [icon]="(this.photoQuestionAllChecked.get(photoSearchCriteria.key) === true ? 'square-outline' : 'checkbox-outline')" 
                                    [rounded]="true" 
                                    [disabled]="this.formGroupDirective.form.controls['pearls_enableProductPictures_'+photoSearchCriteria.key].value === false"
                                    size="small" 
                                    (click)="this.toggleCheckPhotoQuestion(photoSearchCriteria.key, photoSearchCriteria.value.productCategories.productCategory)" 
                                    />
                            </div>
                       </div>                
                        
                        @for(category of photoSearchCriteria.value.productCategories.productCategory; track $index){
                            @if(category.hasProducts){
                                <div class="sub_items_filters">
                                    <marv-sub-item>
                                        <div class="sub_item_filter_title category_title">
                                            {{category.name}}
                                            <div class="button_toggle_check">
                                                <marv-button 
                                                    [icon]="(this.productCategoryAllChecked.get(photoSearchCriteria.key+'_'+category.id) === true ? 'square-outline' : 'checkbox-outline')" 
                                                    [rounded]="true" 
                                                    [disabled]="this.formGroupDirective.form.controls['pearls_enableProductPictures_'+photoSearchCriteria.key].value === false"
                                                    size="small" 
                                                    (click)="this.toggleCheckProductCategory(photoSearchCriteria.key, category.id, category.ranges)" 
                                                    />
                                            </div>
                                        </div>

                                        @for(range of category.ranges; track $index){
                                            @if(range.productChunks.length > 0){
                                                <marv-sub-item>
                                                    <div class="sub_item_filter_title">
                                                        {{range.name}}
                                                        <div class="button_toggle_check">
                                                            <marv-button 
                                                                [icon]="(this.productRangeAllChecked.get(photoSearchCriteria.key+'_'+range.id) === true ? 'square-outline' : 'checkbox-outline')" 
                                                                [rounded]="true" 
                                                                [disabled]="this.formGroupDirective.form.controls['pearls_enableProductPictures_'+photoSearchCriteria.key].value === false"
                                                                size="small" 
                                                                (click)="this.toggleCheckProductRange(photoSearchCriteria.key, range.id, range.productChunks)" 
                                                                />
                                                        </div>
                                                    </div>
                                                    <div class="checkbox_filters">
                                                        @for(rows of range.productChunks; track $index){
                                                            @for(product of rows; track $index){
                                                                <marv-checkbox 
                                                                    [label]="product.name" 
                                                                    [formName]="'pearls_photoProduct_'+photoSearchCriteria.key+'_'+product.id" 
                                                                    [disabled]="this.formGroupDirective.form.controls['pearls_enableProductPictures_'+photoSearchCriteria.key].value === false"
                                                                    labelPlacement="end"
                                                                    /> 
                                                            }
                                                        }
                                                    </div>
                                                </marv-sub-item>
                                            }
                                        }

                                    </marv-sub-item>
                                </div>
                            }
                        }
                    </marv-item>
                }                
            }   
            
            @if(photoSearchCriteria.value.poDmPhotoCriteriaChunks && photoSearchCriteria.value.poDmPhotoCriteriaChunks.length > 0 && photoSearchCriteria.value.productCategories?.hasPosms){
                <div class="filter_title">
                    <marv-section-title label="{{'POSM_QUESTIONNAIRE' | translate}}" />                      
                    <marv-toggle 
                        [formName]="'pearls_enablePosmPictures_'+photoSearchCriteria.key" 
                        [noMargin]="true"
                        />                
                </div>    
                                   
                <marv-item>
                    <div class="item_filter_title">
                        {{'QUESTIONS' | translate}}
                        <div class="button_toggle_check">
                            <marv-button 
                                [icon]="(this.photoPosmQuestionAllChecked.get(photoSearchCriteria.key) === true ? 'square-outline' : 'checkbox-outline')" 
                                [rounded]="true" 
                                [disabled]="this.formGroupDirective.form.controls['pearls_enablePosmPictures_'+photoSearchCriteria.key].value === false"
                                size="small" 
                                (click)="this.toggleCheckPhotoPosmQuestion(photoSearchCriteria.key, photoSearchCriteria.value.poDmPhotoCriteriaChunks)" 
                                />
                        </div>
                    </div>
                    
                    <div class="checkbox_filters">
                        @for(rows of photoSearchCriteria.value.poDmPhotoCriteriaChunks; track $index){
                            @for(question of rows; track $index){
                                <marv-checkbox 
                                    [label]="question.name" 
                                    [formName]="'pearls_photoPosmQuestion_'+photoSearchCriteria.key+'_'+question.id" 
                                    [disabled]="this.formGroupDirective.form.controls['pearls_enablePosmPictures_'+photoSearchCriteria.key].value === false"
                                    labelPlacement="end"
                                    /> 
                            }
                        }
                    </div>
                </marv-item>
               
                @if(photoSearchCriteria.value.productCategories && photoSearchCriteria.value.productCategories.productCategory && photoSearchCriteria.value.productCategories.productCategory.length > 0){ 
                                        
                    <marv-item>
                       <div class="item_filter_title">
                            {{'POSMS' | translate}}
                            <div class="button_toggle_check">
                                <marv-button 
                                    [icon]="(this.photoPosmQuestionAllChecked.get(photoSearchCriteria.key) === true ? 'square-outline' : 'checkbox-outline')" 
                                    [rounded]="true" 
                                    [disabled]="this.formGroupDirective.form.controls['pearls_enablePosmPictures_'+photoSearchCriteria.key].value === false"
                                    size="small" 
                                    (click)="this.toggleCheckPhotoPosm(photoSearchCriteria.key, photoSearchCriteria.value.productCategories.productCategory)" 
                                    />
                            </div>
                       </div>                
                        
                        @for(category of photoSearchCriteria.value.productCategories.productCategory; track $index){
                            @if(category.hasPosms){
                                <div class="sub_items_filters">
                                    <marv-sub-item>
                                        <div class="sub_item_filter_title category_title">
                                            {{category.name}}
                                            <div class="button_toggle_check">
                                                <marv-button 
                                                    [icon]="(this.posmCategoryAllChecked.get(photoSearchCriteria.key+'_'+category.id) === true ? 'square-outline' : 'checkbox-outline')" 
                                                    [rounded]="true" 
                                                    [disabled]="this.formGroupDirective.form.controls['pearls_enablePosmPictures_'+photoSearchCriteria.key].value === false"
                                                    size="small" 
                                                    (click)="this.toggleCheckPosmCategory(photoSearchCriteria.key, category.id, category.ranges)" 
                                                    />
                                            </div>
                                        </div>

                                        @for(range of category.ranges; track $index){
                                            @if(range.posmChunks.length > 0){
                                                <marv-sub-item>
                                                    <div class="sub_item_filter_title">
                                                        {{range.name}}
                                                        <div class="button_toggle_check">
                                                            <marv-button 
                                                                [icon]="(this.posmRangeAllChecked.get(photoSearchCriteria.key+'_'+range.id) === true ? 'square-outline' : 'checkbox-outline')" 
                                                                [rounded]="true" 
                                                                [disabled]="this.formGroupDirective.form.controls['pearls_enablePosmPictures_'+photoSearchCriteria.key].value === false"
                                                                size="small" 
                                                                (click)="this.toggleCheckPosmRange(photoSearchCriteria.key, range.id, range.posmChunks)" 
                                                                />
                                                        </div>
                                                    </div>
                                                    <div class="checkbox_filters">
                                                        @for(rows of range.posmChunks; track $index){
                                                            @for(posm of rows; track $index){
                                                                <marv-checkbox 
                                                                    [label]="posm.name" 
                                                                    [formName]="'pearls_photoPosm_'+photoSearchCriteria.key+'_'+posm.id" 
                                                                    [disabled]="this.formGroupDirective.form.controls['pearls_enablePosmPictures_'+photoSearchCriteria.key].value === false"
                                                                    labelPlacement="end"
                                                                    /> 
                                                            }
                                                        }
                                                    </div>
                                                </marv-sub-item>
                                            }
                                        }

                                    </marv-sub-item>
                                </div>
                            }
                        }
                    </marv-item>
                } 
            }
            
            @if(photoSearchCriteria.value.scDmPhotoCriteriaChunks && photoSearchCriteria.value.scDmPhotoCriteriaChunks.length > 0){
                <div class="filter_title">
                    <marv-section-title label="{{'STORECHECK_PHOTO' | translate}}" />        
                    <marv-button 
                        [icon]="(this.storeCheckPhotoAllChecked.get(photoSearchCriteria.key) === true ? 'square-outline' : 'checkbox-outline')" 
                        [rounded]="true" 
                        [disabled]="this.formGroupDirective.form.controls['pearls_enableStoreCheckDataPictures_'+photoSearchCriteria.key].value === false"
                        size="small" 
                        (click)="this.toggleCheckStoreCheckPhotos(photoSearchCriteria.key, photoSearchCriteria.value.scDmPhotoCriteriaChunks)" 
                        />  
                    <marv-toggle 
                        [formName]="'pearls_enableStoreCheckDataPictures_'+photoSearchCriteria.key" 
                        [noMargin]="true"
                        />                
                </div>   
                @for(structure of photoSearchCriteria.value.scDmPhotoCriteriaChunks; track $index){
                    <div class="sub_items_filters with_padding_left">
                        <marv-sub-item>
                            <div class="sub_item_filter_title">
                                {{structure.group.name}}
                                <div class="button_toggle_check">
                                    <marv-button 
                                        [icon]="(this.storeCheckGroupAllChecked.get(photoSearchCriteria.key+'_'+structure.group.id) === true ? 'square-outline' : 'checkbox-outline')" 
                                        [rounded]="true" 
                                        [disabled]="this.formGroupDirective.form.controls['pearls_enableStoreCheckDataPictures_'+photoSearchCriteria.key].value === false"
                                        size="small" 
                                        (click)="this.toggleCheckStoreCheckGroup(photoSearchCriteria.key, structure.group.id, structure.storeCheckDataModels)" 
                                        />
                                </div>
                            </div>
                            <div class="checkbox_filters">
                                @for(storeCheckData of structure.storeCheckDataModels; track $index){                                    
                                    <marv-checkbox 
                                        [label]="storeCheckData.name" 
                                        [formName]="'pearls_photoStoreCheck_'+photoSearchCriteria.key+'_'+storeCheckData.id" 
                                        [disabled]="this.formGroupDirective.form.controls['pearls_enableStoreCheckDataPictures_'+photoSearchCriteria.key].value === false" 
                                        labelPlacement="end"
                                        />                                     
                                }
                            </div>
                        </marv-sub-item>
                    </div>
                }                
            }
            
            <div class="filter_title">
                <marv-section-title label="{{'RANGES_PHOTO' | translate}}" />    
                <marv-toggle 
                    [formName]="'pearls_enableRangePictures_'+photoSearchCriteria.key" 
                    [noMargin]="true"
                    />                
            </div>   
            
            <div class="filter_title">
                <marv-section-title label="{{'TASKS_PHOTO' | translate}}" />    
                <marv-toggle 
                    [formName]="'pearls_enableTaskPictures_'+photoSearchCriteria.key" 
                    [noMargin]="true"
                    />                
            </div>   
            
            <div class="filter_title">
                <marv-section-title label="{{'IMAGEREC_PHOTO' | translate}}" />    
                <marv-toggle 
                    [formName]="'pearls_enableStitchedPhotos_'+photoSearchCriteria.key" 
                    [noMargin]="true"
                    />                
            </div>   
            
        </div>
    
    }
}